import type { TTabsState, TPhoneState } from "./ui.types";

export const tabsInitialState: TTabsState = {
  conversation: 0,
};

export const phoneInitialState: TPhoneState = {
  error: false,
  fetched: false,
  chatId: undefined,
  loading: false,
  source: undefined,
};
